var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("brand-theme-" + (_vm.config.cssBrand.toLowerCase())),attrs:{"id":"app"}},[_c('div',{staticClass:"container page"},[_c('router-view')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }